import React from 'react';

import { createStyles, withStyles, IconButton, Typography, Box, Tabs, Tab, Dialog, DialogContent, DialogTitle, Grid, Select, FormControlLabel, Checkbox, FormControl, MenuItem } from '@material-ui/core';

import { Check, Close, Lens } from '@material-ui/icons';

import commonStyles from '../common/common.module.css';
import styles from '../attachments/attachments.module.css';

import GhaPickupStatusAwb from '../../models/GhaPickupStatusAwb';

import SecurityChecksContainer from './securityChecks/SecurityChecksContainer';
import OtherChecksContainer from './otherChecks/OtherChecksContainer';
import InfoToWsContainer from './infoToWh/InfoToWsContainer';
import InterlineChecksContainer from './interlineChecks/InterlineChecksContainer';
import GeneralRemarksContainer from '../common/generalRemarks/GeneralRemarksContainer';
import SpecialChecksContainer from './specialsChecks/SpecialChecksContainer';

const materialStyles = () =>
  createStyles({
    green: {
      color: 'green',
      marginRight: '10px'
    },
    red: {
      color: 'red',
      marginRight: '10px'
    },
    selectSpec: {
      backgroundColor: 'transparent',
      '& > div': {
        backgroundColor: 'transparent',
      }
    },
    formControl: {
      width: '50%',
    },
    activeTab: {
      '&.MuiTab-textColorInherit.Mui-selected': {
        backgroundColor: 'var(--primaryblue) !important',
      }
    },
    tabWrapper: {
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    },
    lens: {
      position: 'absolute',
      left: '20px',
    },
    lensGreen: {
      position: 'absolute',
      left: '20px',
      color: 'green'
    },
    lensRed: {
      position: 'absolute',
      left: '20px',
      color: 'red'
    }
  });

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

interface ReadyForCarriageCheckProps {
  classes: any;
  poAwb: GhaPickupStatusAwb;
  flight?: string;
  deliveredDate: string;
  statusTransportation: boolean;
  statusShipper: boolean;
  statusOther: boolean;
  specialStatus: boolean;
  statusInterline: boolean;
  awbCode: string;
  awbNumber: string;
  awbVersion: number;
  doNumber: string;
  handleClose: (type: string) => void;
  setContainerState: (poAwb: GhaPickupStatusAwb, statusTransportation: boolean, statusShipper: boolean) => void;
  setStatusOther: (statusOther: boolean) => void;
  setSpecialStatus: (specialStatus: boolean) => void;
  setStatusIterline: (statusInterline: boolean) => void;
  setStatePoAwb: (poAwb: GhaPickupStatusAwb) => void;
  onlyRead? : boolean;
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const checkElement = (check: boolean ): JSX.Element => {

  if (check) {
    return (
      <Check style={{ color: 'green' }} />
    );
  }

  return (
    <Close style={{ color: 'red' }} />
  );
}

const readyForCarriageCheck = (props: ReadyForCarriageCheckProps) => {

  const { classes } = props;
  const colorClass: string = ( props.statusTransportation && props.statusShipper && props.statusOther ) || (props.statusInterline && props.statusOther) ? classes.green : classes.red;
  const tsaClass: string = ( props.statusTransportation && props.statusShipper) || (props.statusInterline) ? classes.lensGreen : classes.lensRed;
  let securityChecks =  <SecurityChecksContainer
                          poAwb={ props.poAwb }
                          flight={ props.flight }
                          doNumber={ props.doNumber }
                          deliveredDate={ props.deliveredDate }
                          code={ props.awbCode }
                          number={ props.awbNumber }
                          awbVer={ props.awbVersion }
                          setContainerState={ props.setContainerState }
                          statusTransportation={ props.statusTransportation }
                          statusShipper={ props.statusShipper }
                          checkElement={ checkElement }
                          onlyRead={ props.onlyRead }
                        />
  if(props.poAwb.isInterline && !props.poAwb.transportation_number && !props.poAwb.ccsf_approval_number && !props.poAwb.transportation_profile) {
    securityChecks =  <InterlineChecksContainer
                        poAwb={ props.poAwb }
                        doNumber={ props.doNumber }
                        deliveredDate={ props.deliveredDate }
                        code={ props.awbCode }
                        number={ props.awbNumber }
                        awbVer={ props.awbVersion }
                        checkElement={ checkElement }
                        onlyRead={ props.onlyRead }
                        setStatusIterline={ props.setStatusIterline }
                      />
  }

  // Tabs
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      <Dialog
        open={ true }
        onClose={() =>  props.handleClose('rForCheck') }
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth={ 'md' }
      >
        <DialogTitle id="form-dialog-title">
          <div className={ commonStyles.fSpaceBtw }>
            <div className={ commonStyles.fvMiddle }>
            <Lens className={ colorClass } /><div className={ commonStyles.colorPrimary }>R4C Check | { props.awbCode }-{ props.awbNumber } </div>
            </div>
            <div className={ styles.attachmentsButton } onClick={() =>  props.handleClose('rForCheck') } >
              <IconButton aria-label="Close">
                <Close color="primary"/>
              </IconButton>
            </div>
          </div>
          <hr />
        </DialogTitle>
        <DialogContent className={ classes.dialogContent }>
          <Tabs
            value={value}
            onChange={handleChange}
            scrollButtons="off"
            aria-label="scrollable prevent tabs"
            className={ `${ commonStyles.tabContainer } ${ classes.tabWrapper }` }
            variant="fullWidth"
          >
            <Tab className={ `${ commonStyles.tab } ${ classes.activeTab } ${ commonStyles.positionRelative}` } label={<><Lens className={ tsaClass } style={{ fontSize: 14 }} /><span>TSA Security Checks</span></>} />
            <Tab className={ `${ commonStyles.tab } ${ classes.activeTab } ${ commonStyles.positionRelative}` } label={<><Lens className={ props.statusOther ? classes.lensGreen : classes.lensRed } style={{ fontSize: 14 }} /><span>Carrier Specific Checks</span></>} />
            <Tab className={ `${ commonStyles.tab } ${ classes.activeTab } ${ commonStyles.positionRelative}` } label={<> {props.specialStatus ? <Lens className={ classes.lens } style={{ fontSize: 14 }} /> : null }<span>Specials</span></>} />
          </Tabs>
            <TabPanel value={value} index={0}>
            { securityChecks }
          </TabPanel>
          <TabPanel value={value} index={1}>
            <OtherChecksContainer
              doNumber={ props.doNumber }
              awbCode={ props.awbCode }
              deliveredDate={ props.deliveredDate }
              awbNumber={ props.awbNumber }
              checkElement={ checkElement }
              setStatusOther={ props.setStatusOther }
              onlyRead={ props.onlyRead }
              awbVer={ props.awbVersion }
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <SpecialChecksContainer
              doNumber={ props.doNumber }
              awbCode={ props.awbCode }
              deliveredDate={ props.deliveredDate }
              awbNumber={ props.awbNumber }
              checkElement={ checkElement }
              setSpecialStatus={ props.setSpecialStatus }
              onlyRead={ props.onlyRead }
              awbVer={ props.awbVersion }
            />
          </TabPanel>

          <InfoToWsContainer
            poAwb={ props.poAwb }
            doNumber={ props.doNumber }
            code={ props.awbCode }
            number={ props.awbNumber }
            setStatePoAwb={ props.setStatePoAwb }
            onlyRead={ props.onlyRead }
            ver={ props.awbVersion }
          />
           <GeneralRemarksContainer
            poAwb={ props.poAwb }
            doNumber={ props.doNumber }
            code={ props.awbCode }
            number={ props.awbNumber }
            setStatePoAwb={ props.setStatePoAwb }
            onlyRead={ props.onlyRead }
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default withStyles(materialStyles)(readyForCarriageCheck);